export default '/build/02622adf.svg'